import {Box, SvgIcon} from "@mui/material";
import React from "react";

export function CareIcon(props) {
  return(
      <img src="/Icons/weaponCare.svg" alt="care" {...props}/>
  )
}